export const CONTENT_TYPE = 'CONTENT'
export const CONTENT_PENDING = `${CONTENT_TYPE}_PENDING`
export const CONTENT_FULFILLED = `${CONTENT_TYPE}_FULFILLED`
export const CONTENT_REJECTED = `${CONTENT_TYPE}_REJECTED`

export const contentActionCreator = promise => ({
  type: CONTENT_TYPE,
  payload: promise
})
